import { Badge, Text } from '@chakra-ui/react';

const renderText = (value) => {
    return (
        <Text mt={'10px'} textTransform={'capitalize'}>
            {value}
        </Text>
    );
};

export const tableList = [
    {
        name: 'Tanggal/Waktu',
        value: 'date_uploaded',
        withSort: true,
        component: ({ value }) => renderText(value),
    },
    {
        name: 'Uploader',
        value: 'name',
        withSort: true,
        component: ({ value }) => renderText(value),
    },
    {
        name: 'Tipe Sell Out',
        value: 'type_date',
        withSort: true,
        component: ({ value }) => renderText(value),
    },
    {
        name: 'Tipe Upload',
        value: 'upload_type',
        withSort: true,
        component: ({ value }) => renderText(value),
    },
    {
        name: 'Status',
        value: 'status',
        withSort: true,
        component: ({ value }) => {
            const colorMap = {
                Berhasil: { bg: 'success.100', color: 'success.600' },
                Gagal: { bg: 'danger.100', color: 'danger.600' },
            };

            const styles = colorMap[value] || { bg: 'gray.100', color: 'gray.500' };

            return (
                <Badge
                    mt={{ base: '10px', md: '9px', lg: '8px', xl: '7px' }}
                    variant="subtle"
                    bg={styles.bg}
                    color={styles.color}
                    p={'4px 12px'}
                    borderRadius="full"
                    fontSize={'12px'}
                    fontWeight={'600'}
                    textTransform={'capitalize'}
                >
                    {value}
                </Badge>
            );
        },
    },
];
